<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M20.2 12a8.2 8.2 0 1 0-16.4 0 8.2 8.2 0 0 0 16.4 0m1.8 0a10 10 0 1 1-20 0 10 10 0 0 1 20 0"
    />
    <path
      d="M11 6.5a1 1 0 1 1 2 0v5l3 1.5a1 1 0 0 1-.8 1.6l-3.6-1.8a1 1 0 0 1-.5-.8z"
    />
  </svg>
</template>
